export default "__VITE_ASSET__DwkDxPTE__"